import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FTSPeriodField = _resolveComponent("FTSPeriodField")!

  return (_openBlock(), _createBlock(_component_FTSPeriodField, {
    modelValue: _ctx.periodAccessor,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.periodAccessor) = $event)),
    options: _ctx.getOptions,
    disabled: _ctx.disabled,
    levelEventsLabels: ['годы', 'месяцы', 'недели']
  }, null, 8, ["modelValue", "options", "disabled"]))
}